export default {
  spiritual: ['Pray', 'Scripture study', 'Attend church', 'Meditation', 'Gratitude journal'],
  physical: ['Morning walk', 'Stretch & breathe', 'Drink water', 'Healthy meal prep', 'Restful sleep routine'],
  emotional: ['Journaling feelings', 'Breathing exercise', 'Listen to calming music', 'Talk with sponsor', 'Positive affirmations'],
  social: ['Call a friend', 'Attend support group', 'Accountability check-in', 'Family quality time', 'Serve someone'],
};
